<div
  class="c-flight-plan"
  [ngClass]="{
    'c-flight-plan--change':
      this.originDepartureEstimatedDateTime !== undefined || this.destinationArrivalEstimatedDateTime !== undefined,
    'c-flight-plan--cancelled': this.isUnavailable
  }"
>
  <!-- 出発地 -->
  <span class="c-flight-plan__location c-flight-plan__item-1">
    <ng-container *ngIf="this.departureMultiAirportFlg || this.arrivalMultiAirportFlg">
      <span class="c-flight-plan__location-em" *ngIf="this.departureMultiAirportFlg">{{ this.departure }}</span>
      <span class="c-flight-plan__location" *ngIf="!this.departureMultiAirportFlg">{{ this.departure }}</span>
    </ng-container>
  </span>
  <div class="c-flight-plan__time c-flight-plan__item-2">
    <!-- 出発時刻 -->
    <div class="c-flight-plan__time-box">
      <!-- 最新なしの場合 -->
      <ng-container *ngIf="this.originDepartureEstimatedDateTime === undefined">
        <span
          class="c-flight-plan__time-val"
          [innerHTML]="this.originDepartureDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time'"
        ></span>
      </ng-container>
      <!-- 最新ありの場合、取り消し線 -->
      <ng-container *ngIf="this.originDepartureEstimatedDateTime ?? false">
        <span class="u-visually-hidden" [innerHTML]="'reader.DepartureChangeBeforeTime' | staticMsg"></span>
        <span
          [innerHTML]="
            this.originDepartureDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time.old'
          "
        ></span>
      </ng-container>
    </div>
    <!-- 最新出発時刻 -->
    <ng-container *ngIf="this.originDepartureEstimatedDateTime ?? false">
      <!-- 最新出発時刻が日跨ぎの場合-->
      <ng-container
        *ngIf="this.compareStringDate(this.originDepartureDateTime ?? '', this.originDepartureEstimatedDateTime ?? '')"
      >
        <div class="c-flight-plan__time-box">
          <span class="u-visually-hidden" [innerHTML]="'reader.DepartureChangeAfterTime' | staticMsg"></span>
          <span
            style="color: #d91829"
            [innerHTML]="
              this.originDepartureEstimatedDateTime ?? '' | dateFormat : 'flightPlan_departureArrivalDate.dateTime'
            "
          ></span>
        </div>
      </ng-container>
      <!-- 最新出発時刻が日跨ぎでない場合-->
      <ng-container
        *ngIf="!this.compareStringDate(this.originDepartureDateTime ?? '', this.originDepartureEstimatedDateTime ?? '')"
      >
        <div class="c-flight-plan__time-box">
          <span class="u-visually-hidden" [innerHTML]="'reader.DepartureChangeAfterTime' | staticMsg"></span>
          <span
            style="color: #d91829"
            [innerHTML]="
              this.originDepartureEstimatedDateTime ?? ''
                | dateFormat : 'availability.flightPlan_departuredate.time.latest'
            "
          ></span>
        </div>
      </ng-container>
    </ng-container>
    <!-- 深夜出発日時 -->
    <ng-container *ngIf="isJa && this.isLateNightDeparture">
      <div class="c-flight-plan__time-box">
        <span
          *ngIf="!this.originDepartureEstimatedDateTime"
          class="custom-late-night-departure"
          [innerHTML]="this.originDepartureDateTime ?? '' | dateFormat : 'default_departuredate.midnightTime' : true"
        ></span>
        <span
          *ngIf="this.originDepartureEstimatedDateTime"
          class="c-flight-plan__time-text"
          [innerHTML]="this.originDepartureEstimatedDateTime | dateFormat : 'default_departuredate.midnightTime' : true"
        ></span>
      </div>
    </ng-container>
  </div>
  <div
    class="c-flight-plan__period c-flight-plan__item-3"
    [ngClass]="{
      'c-flight-plan__period--0stop': this.numberOfConnections === 0,
      'c-flight-plan__period--1stop': this.numberOfConnections === 1,
      'c-flight-plan__period--2stop': this.numberOfConnections !== 0 && this.numberOfConnections !== 1
    }"
  >
    <!-- 乗継回数 -->
    <p class="c-flight-plan__period-layover">
      <!-- 乗継あり -->
      <ng-container *ngIf="this.numberOfConnections !== 0">
        {{ 'label.connectionCount' | staticMsg : { '0': this.numberOfConnections } }}
      </ng-container>
      <!-- 乗継なしの場合、直通便と表記 -->
      <ng-container *ngIf="this.numberOfConnections === 0">
        {{ 'label.nonStopFlight' | staticMsg }}
      </ng-container>
    </p>
    <!-- 所要時間 -->
    <p
      class="c-flight-plan__period-time"
      [innerHTML]="this.formattedDurationTime | dateFormat : 'default_flightTotalTime'"
    ></p>
  </div>
  <!-- 到着地 -->
  <span class="c-flight-plan__location c-flight-plan__item-4">
    <ng-container *ngIf="this.departureMultiAirportFlg || this.arrivalMultiAirportFlg">
      <span class="c-flight-plan__location-em" *ngIf="this.arrivalMultiAirportFlg">{{ this.arrival }}</span>
      <span class="c-flight-plan__location" *ngIf="!this.arrivalMultiAirportFlg">{{ this.arrival }}</span>
    </ng-container>
  </span>
  <!-- 到着時刻 -->
  <div class="c-flight-plan__time c-flight-plan__item-5">
    <div class="c-flight-plan__time-box">
      <!-- 最新なし -->
      <ng-container *ngIf="this.destinationArrivalEstimatedDateTime === undefined">
        <span
          [innerHTML]="
            this.destinationArrivalDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time'
          "
        ></span>
      </ng-container>
      <!-- 最新ありの場合、取り消し線 -->
      <ng-container *ngIf="this.destinationArrivalEstimatedDateTime ?? false">
        <span class="u-visually-hidden" [innerHTML]="'reader.scheduleArrivalTime' | staticMsg"></span>
        <span
          [innerHTML]="
            this.destinationArrivalDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time.old'
          "
        ></span>
      </ng-container>
    </div>
    <!-- 最新到着時刻 -->
    <ng-container *ngIf="this.destinationArrivalEstimatedDateTime ?? false">
      <!-- 最新到着時刻が日跨ぎの場合-->
      <ng-container
        *ngIf="
          this.compareStringDate(this.destinationArrivalDateTime ?? '', this.destinationArrivalEstimatedDateTime ?? '')
        "
      >
        <div class="c-flight-plan__time-box">
          <span class="u-visually-hidden" [innerHTML]="'reader.newArrivalTime' | staticMsg"></span>
          <span
            style="color: #d91829"
            [innerHTML]="
              this.destinationArrivalEstimatedDateTime ?? '' | dateFormat : 'flightPlan_departureArrivalDate.dateTime'
            "
          ></span>
        </div>
      </ng-container>
      <!-- 最新到着時刻が日跨ぎでない場合-->
      <ng-container
        *ngIf="
          !this.compareStringDate(this.destinationArrivalDateTime ?? '', this.destinationArrivalEstimatedDateTime ?? '')
        "
      >
        <div class="c-flight-plan__time-box">
          <span class="u-visually-hidden" [innerHTML]="'reader.newArrivalTime' | staticMsg"></span>
          <span
            style="color: #d91829"
            [innerHTML]="
              this.destinationArrivalEstimatedDateTime ?? ''
                | dateFormat : 'availability.flightPlan_departuredate.time.latest'
            "
          ></span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
